<template>
  <L1>
    <template slot="slot_title">
      <Select :width="'235px'" :defaultValue="kpi" @input="kpi=$event">
        <option :value="null">請選擇KPI類別</option>
        <option v-for="kpi in kpis" :key="`kpi-${kpi}`" :value="kpi">{{kpi}}</option>
      </Select>
      <RadioTop :options="['本月', '自訂時間']" :defaultValue="daterange" @input="daterange=$event" @same="rangeSelect=true"/>
      <div class="customDate" v-if="daterange==='自訂時間'&&rangeSelect===true">
          <vue-ctk-date-time-picker :range="true" v-model="range"
          :color="'var(--color-pri)'"
          :no-label="true"
          :input-size="'sm'"
          :label="'選取時間範圍'"
          :format="'YYYY-MM-DD'"
          :formatted="'YYYY-MM-DD'"/>
          <button @click="rangeSelect=false"></button>
      </div>
      <Search :defaultValue="searchText" @input="searchText=$event"/>
      <RBtn :bg="'var(--color-checked)'" :text="'匯出'" :icon="'excel1'" :style="{height: '40px', lineHeight: '40px', paddingLeft: '1em'}"/>
      <RBtn :bg="'var(--color-checked)'" :text="'列印'" :icon="'printer'" :style="{height: '40px', lineHeight: '40px', paddingLeft: '1em'}"/>
      <div class="boxToggle" :style="{marginLeft: 'auto'}" :hidden="open">
        <div  @click="open=true"><div class="toggle" :style="{transform: 'rotate(180deg)'}"></div>數值設定</div>
      </div>
      <div class="boxabs" :hidden="!open">
        <div @click="open=false"><div class="toggle"></div>數值設定</div>
        <div class="inputs">
          <div class="money" label="總獎金"><input type="text" id="bonus" v-model="bonus"></div>
          <div class="percentage" label="分配率"><input type="text" v-model="percentage"></div>
        </div>
        <!-- <div class="btns">
          <button class="cancelBtn" @click="open=false">取消</button>
          <button class="saveBtn" @click="setValue">套用</button>
        </div> -->
      </div>
    </template>
    <Table :rows="rows" :len="8">
      <template slot="slot_head">
        <th :style="{width: '180px', textAlign: 'start'}">員工姓名</th>
        <th :style="{width: '180px', textAlign: 'end', paddingRight: '40px'}">個人銷售</th>
        <th :style="{width: '180px', textAlign: 'center'}">崗位總銷售</th>
        <th :style="{width: '180px', textAlign: 'center'}">業績占比</th>
        <th :style="{width: '180px', textAlign: 'center'}">總獎金</th>
        <th :style="{width: '180px', textAlign: 'center'}">分配率</th>
        <th :style="{width: '180px', textAlign: 'center'}">獎金</th>
        <th :style="{width: '180px', textAlign: 'end', paddingRight: '80px'}">應發金額</th>
        <th :style="{}"></th>
      </template>
      <tr slot-scope="{item}" :class="item.type" :style="{border: 'none', height: '64px',backgroundColor: item.type==='summary'?'rgba(227, 120, 120, 0.15)':'transparent'}">
        <td :style="{textAlign: 'start'}">{{item.name}}</td>
        <td :style="{textAlign: 'end', paddingRight: '40px'}">{{item.total_sale}}</td>
        <td :style="{textAlign: 'center'}">{{result.total}}</td>
        <td :style="{textAlign: 'center'}">{{item.myPercentage ? `${item.myPercentage}%` : '-'}}</td>
        <td :style="{textAlign: 'center'}">{{bonus || '-'}}</td>
        <td :style="{textAlign: 'center'}">{{percentage ? `${percentage}%` : '-'}}</td>
        <td :style="{textAlign: 'center'}">{{bonusMoney || '-'}}</td>
        <td :style="{textAlign: 'end', paddingRight: '80px'}">{{`$${item.myBonus}` || '-'}}</td>
        <td></td>
      </tr>
    </Table>
  </L1>
</template>

<script>
import Table from '../../components/tables/t2.vue'
import RBtn from '../../components/btn/round.vue'
import Search from '../../components/input/search.vue'
import RadioTop from '../../components/radio/r1.vue'
import Select from '../../components/select.vue'
import L1 from '../../components/layout/L1.vue'
import { getapi } from '../../store/fetch'
export default {
  components: {
    L1,
    Select,
    RadioTop,
    Search,
    RBtn,
    Table
  },
  data () {
    return {
      open: false,
      kpis: [],
      kpi: null,
      daterange: '本月',
      range: {
        start: this.moment().startOf('month').format('yyyy-MM-DD'),
        end: this.moment().endOf('month').format('yyyy-MM-DD')
      },
      rangeSelect: false,
      searchText: null,
      result: null,
      bonus: 0,
      percentage: 0
    }
  },
  computed: {
    rows () {
      return !this.result ? [] : []
        .concat(...this.result.sale_each_range.map(({ name, total_sale: totalSale }) => {
          return {
            type: 'staff',
            name,
            total_sale: totalSale,
            myPercentage: Math.floor(10000 * (totalSale / this.result.total)) / 100,
            myBonus: this.bonusMoney ? Math.floor(Math.floor(10000 * (totalSale / this.result.total)) * this.bonusMoney / 10000) : 0
          }
        }))
        .concat({ type: 'summary', name: '正職合計', total_sale: this.empSale, myPercentage: this.empSale ? Math.floor(10000 * ((this.empSale || 0) / this.result.total)) / 100 : 0, myBonus: this.bonusMoney ? Math.floor(Math.floor(10000 * (this.empSale / this.result.total)) * this.bonusMoney / 10000) : 0 })
        .concat(...this.result.sale_each_range_pt.map(({ name, total_sale: totalSale }) => {
          return {
            type: 'pt',
            name,
            total_sale: totalSale,
            myPercentage: Math.floor(10000 * (totalSale / this.result.total)) / 100,
            myBonus: this.bonusMoney ? Math.floor(Math.floor(10000 * (totalSale / this.result.total)) * this.bonusMoney / 10000) : 0
          }
        }))
        .concat({ type: 'summary', name: 'ＰＴ合計', total_sale: this.ptSale, myPercentage: this.ptSale ? Math.floor(10000 * ((this.ptSale || 0) / this.result.total)) / 100 : 0, myBonus: this.bonusMoney ? Math.floor(Math.floor(10000 * (this.ptSale / this.result.total)) * this.bonusMoney / 10000) : 0 })
    },
    bonusMoney () {
      return (this.bonus || 0) * (this.percentage || 0) / 100
    },
    empSale () {
      return this.result ? this.result.sale_each_range.map(e => e.total_sale).reduce((a, b) => a + b, 0) : 0
    },
    ptSale () {
      return this.result ? this.result.sale_each_range_pt.map(e => e.total_sale).reduce((a, b) => a + b, 0) : 0
    }
  },
  watch: {
    daterange () {
      if (this.daterange === '自訂時間') {
        this.rangeSelect = true
      } else if (this.daterange === '本月') {
        this.range = {
          start: this.moment().startOf('month').format('yyyy-MM-DD'),
          end: this.moment().endOf('month').format('yyyy-MM-DD')
        }
      }
    },
    kpi () {
      this.getdata()
    },
    range: {
      handler () {
        if (this.range.start && this.range.end && this.kpi) {
          this.getdata()
        }
      },
      deep: true
    }
  },
  async mounted () {
    const kpis = await getapi('cmcpAttendance/kpi')
    this.kpis = kpis.map(e => e.name)
  },
  methods: {
    setValue () {},
    async getdata () {
      if (this.kpi) {
        this.result = await getapi(`cmcpAttendance/kpi/result/${this.kpi}?` + new URLSearchParams({
          start: this.moment(this.range.start).startOf('day').toISOString(),
          end: this.moment(this.range.end).endOf('day').toISOString()
        }))
      }
    }
  }
}
</script>

<style lang="scss" scoped>
td:nth-child(4) {}
tr:not(.summary) {
  &:hover {
    background-color: var(--color-infobox);
  }
  td {
    font-weight: 400;
    font-size: 20px;
    line-height: 23px;
    letter-spacing: 0.1em;
    color: #5E5E5E;
  }
}
td:nth-child(4) {
  background-color: rgba(191, 227, 245, 0.2);
}
tr.summary td {
  &:nth-child(1), &:nth-child(2), &:nth-child(3), &:nth-child(4), &:nth-child(8) {
    font-weight: 700;
  }
  &:nth-child(8) {
    color: #E37878;
  }
  font-size: 24px;
  line-height: 28px;
  text-align: center;
  letter-spacing: 0.1em;

}
.inputs {
  margin-top: 27px;
  gap: 20px;
  display: flex;
  flex-direction: column;
  &>div {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-inline: 10px;
    &::before {
      content: attr(label);
      display: inline-block;
      width: 145px;
      text-align: start;
    }
    &.money::after {
      content: '$';
      position: absolute;
      right: 124px;
      font-size: 16px;
    }
    &.percentage::after {
      content: '%';
      position: absolute;
      right: 48px;
      font-size: 16px;
    }
    &.x::after {
      content: '倍';
      position: absolute;
      right: 48px;
      font-size: 16px;
    }
    &.money>input[type=text] {
      padding-left: 32px;
      padding-right: 13px;
    }
    &.percentage>input[type=text] {
      padding-right: 36px;
    }
    &.x>input[type=text] {
      padding-right: 40px;
    }
    input[type=text] {
      width: 115px;
      height: 40px;
      box-sizing: border-box;
      border-radius: 3px;
      border: 1px solid #C4C4C4;
      text-indent: 12px;
      font-size: 18px;
      display: flex;
      align-items: center;
      text-align: end;
      color: #5E5E5E;
    }
  }
}
.toggle {
  display: inline-flex;
  width: 16px;
  height: 13px;
  background-color: var(--color-pri);
  mask: center / contain no-repeat url(/triangle.svg);
  transform: rotate(0deg);
}
.boxabs {
  position: absolute;
  top: 88px;
  width: 285px;
  height: fit-content;
  right: 32px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
  background-color: var(--color-infobox);
  z-index: 200;
  padding: 0 20px 23px 20px;
  font-weight: 400;
  font-size: 18px;
  letter-spacing: 0.1em;
  color: var(--color-pri);
  &>div:nth-child(1) {
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;

  }
}

.btns {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 28px;
  margin-top: 23px;
}
.saveBtn, .cancelBtn {
width: 100px;
height: 35px;
background-color: #B8B8B8;
border-radius: 20px;
font-weight: 400;
font-size: 16px;
letter-spacing: 0.1em;
color: #FFFFFF;
border: none;
}
.saveBtn {
  background-color: #E37878;
}
.boxToggle {
  width: 235px;
  height: 40px;
  background: var(--color-infobox);
  border-radius: 3px;
  font-weight: 400;
  font-size: 18px;
  letter-spacing: 0.1em;
  color: var(--color-pri);
  margin-right: 32px;
  padding-inline: 20px;
  &>div:nth-child(1) {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
  }
}

.customDate {
  display: flex;
  position: fixed;
  top: 74px;
  left: 860px;
  width: 400px;
  height: 80px;
  box-shadow: 4px 0px 15px rgba(0, 0, 0, 0.25);
  margin-top: 10px;
  background-color: #FFFFFF;
  border-radius: 5px;
  z-index: 1;
  padding: 20px;
  box-sizing: border-box;
  button {
    height: 36px;
    width: 36px;
    border: none;
    padding: 0;
    background-color: transparent;
    &::before {
      content: '';
      display: inline-block;
      width: 36px;
      height: 36px;
      background-color: var(--color-checked);
      mask: center / 32px no-repeat url(/close.svg);
      font-size: 24px;
    }
  }
}
</style>
